import { useContext } from "react";
import { BrandContext } from "./BrandProvider";
import type { BrandConfig } from "./brand.config";

/** Access the active brand config anywhere in the tree. */
export function useBrand(): BrandConfig {
  return useContext(BrandContext).brand;
}

/** Update the live brand (used by Settings for the white-label preview). */
export function useSetBrand(): (patch: Partial<BrandConfig>) => void {
  return useContext(BrandContext).setBrand;
}
